import { Context } from 'Context/Context';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { getCaseCountApi, markNotificationAsViewedApi, userListCasesApi } from 'Constants';
import SortingOptions from './SortingOptions';
import ReqToCloseCases from './ReqToCloseCases';
import ClosedCases from './ClosedCases';
import { CaseListLayout, ResultLine, CardSkeleton, CasePager } from './CaseListUI';
import { FilterBar } from './CaseFilters';
import { CASE_TYPES, readCaseType, writeCaseType, useRestoreListScroll } from './CaseStage';

// Closed Cases (header menu) — Pending closing · Closed cases
const TYPES = CASE_TYPES['3'];   // shared with the case page (CaseStage.jsx)

function OtherCasesClosed({attorney, updateComp, setUpdateComp}) 
{
    const [innerPanel, setInnerPanel] = useState(() => readCaseType('3', 0));
    const {userDetails, makeApiCallFunc, filters, setFilters, reqRevCountArr, setReqRevCountArr} = useContext(Context);
    const userInfo = attorney ? attorney?.userId :  userDetails;
    const {setUpdateLoggedinData, offset, setOffset} = useContext(Context);
    
    const [sendCount, setSendCount] = useState(true);
    const [caseTypeCount, setCaseTypeCount] = useState(["reqToClose", "closed"]);

    const [selectedSort, setSelectedSort] = useState("Date of incident - recent first");

    const [cases, setCases] = useState(null);
    const fetchSeq = useRef(0);   // ignore responses from superseded requests
    const [count, setCount] = useState({
        "reqToClose" : 0,
        "closed" : 0,
    });
    const [isVerified, setIsVerified] = useState(userInfo?.verified);

    const [totalCases, setTotalCases] = useState(0);
    // const {offset, setOffset} = useContext(Context);
    //     useEffect(() => {
    //             setOffset(0);
    //         },[])
    const [limit, setLimit] = useState(isVerified? 5 : 3);
    const [closedCaseCount, setClosedCaseCount] = useState(0);

    const [sortOptions, setSortOptions] = useState(JSON.stringify({"field" : "dateInfo", "order" : -1}));
    const processReqReviewCount = (data) => {
        let idWithReqReviewArr = null;
        if(data?.length !== 0 )
            {
                idWithReqReviewArr = {}
                data?.map((item) => {
                       // let incrCounter = item.deniedCount !== 0 ? (item.caseStatus === "denied" ? item.deniedCount : parseInt(item.deniedCount) + 1 ) : 1;
                      let incrCounter =  1 ;
                        
                       let statusVariable =  (item.caseStatus === "denied" && item.userId !== userInfo._id) ? "requested" : item.caseStatus;
                        if(idWithReqReviewArr[item.caseId])
                        {   
                            if(idWithReqReviewArr[item.caseId][statusVariable])
                            {
                                idWithReqReviewArr[item.caseId][statusVariable] = item.caseStatus === "denied" ? item.deniedCount : idWithReqReviewArr[item.caseId][statusVariable] + incrCounter; 
                            }
                            else
                            {
                                idWithReqReviewArr[item.caseId][statusVariable] = item.caseStatus === "denied" ? item.deniedCount : incrCounter;
                            }
                        }
                        else
                        {
                            idWithReqReviewArr[item.caseId] = { [statusVariable] : item.caseStatus === "denied" ? item.deniedCount : incrCounter}
                        }
                })  
            }
                console.log(idWithReqReviewArr)
                return idWithReqReviewArr;

    }
    useEffect(() => {
        setCases(null);
        setReqRevCountArr(null);
        setTotalCases(0);
        const mine = ++fetchSeq.current;
        makeApiCallFunc(
        getListType(),
        {
            filters,
            sortOptions : JSON.parse(sortOptions),
            sendCount: sendCount,   
            caseTypeCount: caseTypeCount,
            limit: limit,
            userId: userInfo?._id,
            offset: offset
        },
        ({data}) => 
        {
            if (mine !== fetchSeq.current) return;
            setCases(data?.cases || []);
            setTotalCases(data?.totalCount ? data?.totalCount : 0);
                setReqRevCountArr(processReqReviewCount(data?.userCaseStatusCount))

           if(innerPanel === 0)
            {
            setCount(prev => ({...prev, "reqToClose" : data?.totalCount ? data?.totalCount : 0}));
            }
            else
            {

            setCount(prev => ({...prev, "closed" : data?.totalCount ? data?.totalCount : 0}));
            }
              
        },
        (data) => { console.log(data); if (mine === fetchSeq.current) setCases([]); },
        null,
        true
        )
        // makeApiCallFunc(
        //     getListType(),
        //     {
        //         filters,
        //         sortOptions : JSON.parse(sortOptions),
        //         sendCount: sendCount,   
        //         caseTypeCount: caseTypeCount,
        //         limit: limit,
        //         offset: offset,
        //         loadReqRev: true,
        //     userId: userInfo?._id,

        //     },
        //     ({data}) => 
        //     {
        //         setReqRevCountArr(processReqReviewCount(data))
        //     },
        //     (data) => { console.log(data)}
        //     ) 
        makeApiCallFunc(getCaseCountApi,
            {
                statuses: (innerPanel === 0 ? ["closed"] : ["reqToClose"]),
                userId: userInfo?._id,
                takeTeamup: true


            },
            ({data}) => 
            {
                data.map((d) => setCount(prev => ({...prev, [d._id] : d.count})))
            },
            (data) => { console.log(data)}
            )
    },[updateComp, innerPanel, offset, userInfo])
    
    const current = TYPES.find((t) => t.key === innerPanel) || TYPES[0];
    const emptyText = { title: 'No ' + current.label.toLowerCase() + ' yet', body: 'Cases will appear here as they move into this stage. Try changing your filters.' };
    const builder = (activePanel) => {
            switch (activePanel)
            {
                case 0 :
                return <ReqToCloseCases attorney={attorney} reqRevCountArr={reqRevCountArr}  cases={cases} setUpdateComp={setUpdateComp} emptyText={emptyText}/>
                case 1 :
                return <ClosedCases attorney={attorney} reqRevCountArr={reqRevCountArr}  cases={cases} setUpdateComp={setUpdateComp} emptyText={emptyText}/>
                default:
                return null
            }
    }
    const getListType =() => 
    {
        switch (innerPanel)
            {
                case 0 :
                return userListCasesApi+"reqToClose"
                case 1 :
                    return userListCasesApi+"closed"
                default:
                return userListCasesApi+"reqToClose"

            }
    }
    const selectType = (key) => {
        if (key === 1) {
            makeApiCallFunc(markNotificationAsViewedApi,
                { userId: userDetails?._id, updateData: { isClosedNotificationViewed: true } },
                () => setUpdateLoggedinData(prev => !prev),
                () => console.log("error in closed notification viewed"),
                null, true
            );
        }
        setOffset(0);
        setInnerPanel(key);
        writeCaseType('3', key);
    };
    useRestoreListScroll('3', cases !== null);
    const railItems = TYPES.map((t) => ({
        ...t,
        count: t.key === 0 ? (count?.reqToClose || 0) : (count?.closed || 0),
        // no action tabs in this section (pending closing waits on the client) - no dot
    }));
    const countFor = (draft) => ({
        url: getListType(),
        body: { filters: draft, sortOptions: null, limit: 1, offset: 0, userId: userInfo?._id },
        pick: (d) => (d?.totalCount || 0),
    });

  return (
    <CaseListLayout
        attorney={attorney}
        sectionKey="3"
        railItems={railItems}
        activeKey={innerPanel}
        onSelect={selectType}
        setUpdateComp={setUpdateComp}
    >
        <FilterBar attorney={attorney} setUpdateComp={setUpdateComp} countFor={countFor}/>
        <ResultLine
            label={current.label}
            total={totalCases}
            loading={!cases}
            right={<SortingOptions setOffset={setOffset} setUpdateComp={setUpdateComp} sortOptions={sortOptions} setSortOptions={setSortOptions} selectedSort={selectedSort} setSelectedSort={setSelectedSort}/>}
        />
        {cases ? builder(innerPanel) : <CardSkeleton/>}
        <CasePager
            offset={offset}
            limit={limit}
            total={isVerified ? totalCases : offset + (cases?.length || 0)}
            shown={cases?.length || 0}
            onPage={(next) => setOffset(next)}
        />
    </CaseListLayout>
  )
}

export default OtherCasesClosed
